import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'
import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Rental } from './rental'
import { rentalActions } from './rental.actions'
import * as fromRental from './rental.reducer'
import { RentalService } from './rental.service'

@Injectable()
export class RentalEffects extends ResourceEffects<Rental> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public rentalService: RentalService
  ) {
    super(fromRental.FEATURE_NAME, rentalService, rentalActions, actions$)
  }
}
